export const routes = {
    dashboard: {
        path: "dashboard",
    },
    widgets: {
        path: "widgets",
    },
    settings: {
        path: "settings",
    },
    headerFooterBuilder: { 
        path: "elementor-hf" 
    },
    onboarding: { 
        path: "onboarding" 
    }
}